var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors,
    borders = _ref.borders;
  return {
    itemMargin: spacing.xxSmall,
    itemBeforeMargin: spacing.xSmall,
    itemPadding: spacing.xSmall,
    questionMargin: spacing.xSmall,
    questionBorder: borders.widthSmall,
    questionBorderColor: colors.tiara,
    questionColor: colors.porcelain,
    dividerMargin: spacing.small,
    dividerBorder: borders.widthMedium,
    dividerBorderColor: colors.licorice
  };
};
export default generateComponentTheme;